import {
  default as MuiMasonry,
  type MasonryProps as MuiMasonryProps,
  masonryClasses as muiMasonryClasses,
} from '@mui/lab/Masonry';

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const Masonry = MuiMasonry;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export type MasonryProps = MuiMasonryProps;
/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const masonryClasses = muiMasonryClasses;
